<template>
  <div
    :class="{
    page: true,
    graphic: true,
    overlayed: showInformation,
    large: large,
    home: isHomepage
  }"
    ref="page"
    v-bind:style="{ transform: `scale(${scale})`,
      maxWidth: large && isMaxWidth ? `${widthMax}` : null,
      minWidth: isMinWidth ? `${widthMin}` : null,
    }"
  >
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <img v-if="currentScene === 'home'" class="page__bg" src="../assets/bg-map.jpg" alt />
    </transition>

    <div class="page__inner">
      <header class="page__header">
        <div class="page__info">
          <transition
            name="slide"
            enter-class="slide-enter"
            enter-active-class="animated slideInLeft"
            leave-active-class="animated fadeOut"
            mode="out-in"
          >
            <h1
              class="page__title"
              v-if="true"
              v-html="currentTitle[lang]"
              :key="currentTitle['de'] + currentScene"
            />
          </transition>
          <transition
            name="slide"
            enter-active-class="animated slideInLeft"
            leave-active-class="animated fadeOut"
            mode="out-in"
          >
            <div
              class="page__subtitle"
              v-if="true"
              v-html="currentSubtitle[lang]"
              :key="currentSubtitle['de'] + currentScene"
            />
          </transition>
          <div class="page__information-pane" v-if="currentInformation">
            <transition
              name="slide"
              enter-active-class="animated slideInLeft"
              leave-active-class="animated fadeOut"
              mode="out-in"
            >
              <button
                class="page__info--button"
                v-if="showInformation === false && isHomepage"
                :key="currentSubtitle['de'] + currentScene"
                @click="showInformation = true"
              >{{ lang === 'en' ? "More Information" : "Mehr Erfahren" }}</button>
            </transition>

            <transition
              name="slide"
              enter-active-class="animated slideInLeft"
              leave-active-class="animated fadeOut"
              mode="out-in"
            >
              <div
                class="page__information-content"
                v-if="showInformation || !isHomepage"
                :key="currentInformation.title['de'] + currentScene"
              >
                <div class="page__information-content__inner">
                  <div
                    class="page__information-content__title"
                    v-html="currentInformation.title[lang]"
                  ></div>
                  <div class="page__information-content__body">
                    <div v-html="currentInformation.text[lang]" />
                    <button v-if="isHomepage" @click="showInformation = false" class="close" />
                  </div>
                  <div class="page__information-content__links">
                    <a
                      v-for="link in currentInformation.links[lang]"
                      :href="link.url"
                      :key="link.url"
                      target="_blank"
                    >{{link.text}}</a>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <img
          :src="logoSrc"
          class="page__logo"
          @click="setScene({
            scene: 'home',
            type: null
          });"
        />
      </header>
      <div class="page__scenes">
        <div class="page__row">
          <SouverentyScene class="page__scene" type="souverenty" flag="right" />
        </div>
        <div class="page__row">
          <InteroperabilityScene class="page__scene" type="interoperability" flag="left" />
          <SustainabilityScene class="page__scene" type="sustainability" flag="right" />
        </div>
      </div>
      <footer class="page__footer">
        <div
          class="page__back-btn"
          @click="setHomeScreen"
          v-if="currentScene!=='home'"
        >{{ btnText[lang] }}</div>
        <div class="page__lang">
          <LangSwitcher />
        </div>
      </footer>

      <SocialShare />

      <transition
        name="fade-in-overlay"
        enter-active-class="animated"
        leave-active-class="animated"
        mode="out-in"
      >
        <div v-if="showInformation" class="overlay" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import LangSwitcher from "@/components/LangSwitcher";
import MainLogo from "@/assets/logo.svg";
import SustainabilityScene from "@/scenes/SustainabilityScene";
import InteroperabilityScene from "@/scenes/InteroperabilityScene";
import SouverentyScene from "@/scenes/SouverentyScene";
import SocialShare from "@/components/SocialShare";

import data from "@/data";

export default {
  name: "basic-page",
  data() {
    return {
      scenes: data.filter(s => s.id !== "home"),
      showInformation: false,
      scale: 1,
      large: false,
      widthMax: "auto",
      widthMin: "auto",
      isMinWidth: false,
      isMaxWidth: false,
      btnText: {
        en: "Back",
        de: "Zurück"
      },
      codeText: {
        en: "More info:",
        de: "Mehr info:"
      }
    };
  },

  computed: {
    ...mapState(["lang", "currentScene", "subScene"]),
    ...mapGetters(["currentTitle", "currentSubtitle", "currentInformation"]),
    logoSrc() {
      return MainLogo;
    },
    currentSceneObj() {
      return data.find(s => s.id === this.currentScene);
    },
    isHomepage() {
      return this.currentScene === "home";
    },
    scenes_t() {
      if (this.isHomepage) {
        return data.filter(s => s.id !== "home");
      } else {
        const selectedScene = data.find(s => s.id === this.currentScene);

        return selectedScene.subscenes && selectedScene.subscenes.length
          ? selectedScene.subscenes
          : [];
      }
    }
  },

  methods: {
    ...mapMutations(["setScene"]),
    setHomeScreen() {
      this.setScene({
        scene: this.subScene ? this.currentScene : "home",
        type: null
      });
    }
  },
  mounted() {
    this.setHomeScreen();
    this.scale =
      window.innerWidth > 1024 ? (window.innerWidth / 1000) * 0.5207 : 0.534528;
    this.large = window.innerWidth > 1920 ? true : false;

    this.widthMax = 1920 + "px";
    if (window.innerWidth > 1920 && window.innerHeight > 1080) {
      if (1080 * this.scale > window.innerHeight) {
        this.isMaxWidth = true;
        this.scale = (window.innerHeight / 1000) * 0.9255;
        this.widthMax = window.innerWidth / this.scale + "px";
      }
    } else {
      this.widthMax = "auto";
      if (
        this.$refs.page.scrollHeight * this.scale > window.innerHeight &&
        window.innerWidth > 1024
      ) {
        this.isMinWidth = true;
        this.scale = (window.innerHeight / 1000) * 0.9255;
        this.widthMin = window.innerWidth / this.scale + "px";
      }
    }

    window.onresize = event => {
      if (window.innerWidth > 1024) {
        this.scale = (window.innerWidth / 1000) * 0.5207;
      }

      this.large = window.innerWidth > 1920 ? true : false;

      this.isMaxWidth = false;
      this.isMinWidth = false;
      this.widthMax = 1920 + "px";
      if (window.innerWidth > 1920 && window.innerHeight > 1080) {
        if (1080 * this.scale > window.innerHeight) {
          this.isMaxWidth = true;
          this.scale = (window.innerHeight / 1000) * 0.9255;
          this.widthMax = window.innerWidth / this.scale + "px";
        }
      } else {
        this.widthMax = "auto";
        if (
          this.$refs.page.scrollHeight * this.scale > window.innerHeight &&
          window.innerWidth > 1024
        ) {
          this.isMinWidth = true;
          this.scale = (window.innerHeight / 1000) * 0.9255;
          this.widthMin = window.innerWidth / this.scale + "px";
        }
      }
    };
  },

  components: {
    LangSwitcher,
    SustainabilityScene,
    InteroperabilityScene,
    SouverentyScene,
    SocialShare
  }
};
</script>

<style lang="scss">
@import "~animate.css";

.abs-scene {
  position: absolute;
}

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.6;
  background-color: #b2c6d2;
  z-index: 9;
  transition: 0.6s ease;
}

.fade-in-overlay {
  &-enter,
  &-leave-to {
    opacity: 0;
  }

  &-enter-to,
  &-leave {
    opacity: 0.6;
  }
}

.page {
  // background: #2789AF;
  min-width: 1920px;
  min-height: 1080px;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  transform-origin: 0 0;

  &.large {
    max-height: 1080px;
    min-width: auto;
  }

  &__inner {
    // max-width: 1920px;
    // min-width: 1024px;
    // min-height: 1080px;
  }

  &.overlayed {
    .page__header {
      z-index: 10;
    }
  }

  &.graphic {
    background: url("~@/assets/bg-inner.jpg") no-repeat center;
    background-size: cover;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__header {
    background: url("~@/assets/title-bg.svg") bottom left no-repeat;
    background-size: cover;
    height: 320px;
    padding: 75px;
  }

  &__info {
    max-width: 730px;
  }

  &__title {
    color: #004169;
    font-size: 55px;
    line-height: 66px;
    margin: 0;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  &__subtitle {
    font-size: 28px;
    letter-spacing: 0.021em;
    color: #ffffff;
    font-weight: 500;
  }

  &__information {
    &-pane {
      position: absolute;
      bottom: 0;
      left: 0;
      // margin-top: 0;
      max-width: 580px;
      width: 580px;
      height: calc(100% - 325px);
      z-index: 10;

      // .page.home & {
      //   top: 310px;
      // }
    }

    &-content {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 30px 75px 0;
      background: linear-gradient(
        160deg,
        rgba(255, 255, 255, 0.5) 0%,
        rgba(255, 255, 255, 0.5) 80%,
        transparent 80%,
        transparent 100%
      );
      z-index: 10;

      &__inner {
        overflow-y: overlay;
        max-height: 550px;
        min-height: 420px;
      }

      &::after {
        // content: "";
        position: absolute;
        left: 0;
        right: 0;
        border-left: 0 solid transparent;
        border-right: 590px solid transparent;
        bottom: auto;
        top: 100%;
        border-bottom: none;
        // border-top: 240px solid rgba(255, 255, 255, 0.25);
      }

      .page.overlayed & {
        // background-color: rgba(255, 255, 255, 0.75);
      }

      .page.overlayed &::after {
        // border-top: 240px solid rgba(255, 255, 255, 0.75);
      }

      .close {
        position: absolute;
        right: 32px;
        top: 32px;
        width: 32px;
        height: 32px;
        opacity: 0.3;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;

        &:hover {
          opacity: 1;
        }

        &:before,
        &:after {
          position: absolute;
          top: 0;
          left: 15px;
          content: " ";
          height: 33px;
          width: 2px;
          background-color: #333;
        }

        &:before {
          transform: rotate(45deg);
        }

        &:after {
          transform: rotate(-45deg);
        }
      }

      &__title {
        margin-bottom: 20px;
        font-size: 28px;
        letter-spacing: 0.021em;
        color: #1881c0;
      }

      &__body {
        margin-bottom: 20px;
        font-size: 22px;
        color: #004169;
      }

      &__links {
        margin-bottom: 20px;

        a {
          display: inline-block;
          margin-top: 5px;
          font-size: 22px;
          color: #1881c0;
        }
      }
    }
  }

  .page.home {
    .page__scenes {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 220px;
      margin-top: 0;
    }
  }

  &__logo {
    position: absolute;
    right: 0;
    top: 75px;
    z-index: 1;
    cursor: pointer;
  }

  &__scenes {
    // position: absolute;
    margin-top: -150px;
  }

  &__row {
    margin-top: -50px;
    text-align: center;
  }

  &__scene {
    display: inline-block;

    & + & {
      margin-left: 175px;
    }
  }

  &__lang {
    position: absolute;
    right: 65px;
    bottom: 70px;
  }

  &__back-btn {
    position: absolute;
    left: 65px;
    bottom: 70px;
    color: #ffffff;
    font-size: 28px;
    text-decoration: none;
    padding-left: 30px;
    min-height: 30px;
    cursor: pointer;
    z-index: 11;

    &::before {
      content: "";
      display: inline-block;
      width: 36px;
      height: 42px;
      background: url("../assets/back-button.svg") no-repeat center;
      background-size: cover;
      margin-top: -5px;
      margin-right: 15px;
      vertical-align: middle;
    }
  }

  &__code {
    position: absolute;
    left: 75px;
    bottom: 70px;
    color: #ffffff;
    font-size: 14px;

    .label {
      margin-bottom: 5px;
    }
  }
}

[data-name^="PULSE"] {
  // animation-name: pulse;
  // animation-duration: 3s;
  // animation-timing-function: ease-in;
  // animation-direction: alternate;
  // animation-iteration-count: infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

.slide-enter {
  opacity: 0;
}

.page__info--button {
  position: relative;
  display: inline-block;
  word-wrap: break-word;
  text-align: left;
  font-size: 30px;
  left: 70px;
  color: #004169;
  font-weight: 500;
  min-height: -5px;
  padding: 15px 35px 15px 80px;
  background: url("~@/assets/flag-modal.svg") no-repeat right center;
  background-size: contain;
  white-space: nowrap;
  border: none;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    width: 69px;
    height: 69px;
    top: -4px;
    left: -10px;
    background: url("~@/assets/info-icon.svg") no-repeat right center;
  }
}
</style>
